export default "__VITE_ASSET__DupfnqeI__"